import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialogDelete.title'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
        color: 'red',
        emit: 'delete'
      }],
      "color": "red"
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.showDeletePrompt(_vm.deletePrompt);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialogDelete.message')) + "\n  ")]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialogRun.title'),
      "open": _vm.runPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialogRun.title'),
        color: 'green',
        emit: 'triggerExport'
      }],
      "color": "green"
    },
    on: {
      "cancel": function ($event) {
        _vm.runPrompt = false;
      },
      "triggerExport": function ($event) {
        return _vm.runJob(_vm.runPrompt);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialogRun.message')) + "\n  ")]), _c(VDataTable, {
    attrs: {
      "loading": false,
      "server-items-length": _vm.serverItemsLength,
      "items": _vm.scheduledJobs,
      "search": _vm.searchItem,
      "options": _vm.tableOptions,
      "item-key": "id",
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooter
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.active",
      fn: function ({
        item
      }) {
        return [_c(VSwitch, {
          key: `item.id-active`,
          staticClass: "activeSwitch",
          attrs: {
            "false-value": false,
            "color": _vm.color,
            "hide-details": ""
          },
          on: {
            "change": value => _vm.handleActiveChange(item, value)
          },
          model: {
            value: item.active,
            callback: function ($$v) {
              _vm.$set(item, "active", $$v);
            },
            expression: "item.active"
          }
        })];
      }
    }, {
      key: "item.tenantId",
      fn: function ({
        item
      }) {
        return [_vm._v(_vm._s(_vm.tenantIdToName(item.tenantId)))];
      }
    }, {
      key: "item.nextExecution",
      fn: function ({
        item
      }) {
        return [_vm._v("\n      " + _vm._s(_vm.localizeDate(item.nextExecution)) + "\n    ")];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_vm.isIntegrationConfigBroken(item) ? _c(VIcon, {
          staticClass: "danger--text mr-2",
          attrs: {
            "color": _vm.danger,
            "small": "",
            "title": _vm.$i18n_t('BackgroundJobs.ScheduledExports.tableRows.sendoutConfigurationError')
          }
        }, [_vm._v("\n        fal fa-exclamation-circle\n      ")]) : _vm._e(), _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.copy'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('show-details', item, true);
            }
          }
        }, [_vm._v("\n        fal fa-copy\n      ")]), _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.view'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('show-details', item);
            }
          }
        }, [_vm._v("\n        fal fa-eye\n      ")]), _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.deletePrompt = item.id;
            }
          }
        }, [_vm._v("\n        fal fa-trash-alt\n      ")]), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('BackgroundJobs.ScheduledExports.tableRows.triggerExport'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.runPrompt = item.id;
            }
          }
        }, [_vm._v("\n        fal fa-play\n      ")])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n      " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n    ")];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };